<template>
  <div class="test" v-if="!isResult">
    <div class="test__progress">{{ progress }}%</div>
    <swiper
      ref="mySwiper"
      :options="swiperOption"
      @ready="handleSwiperComponentReady"
    >
      <swiper-slide
        v-for="(item, index) in testItems"
        :key="index"
        class="test__wrapper"
      >
        <div class="test__container">
          <button
            class="test__prevButton"
            @click="prev(index)"
            v-if="index !== 0"
          >
            <span class="test__prevIcon"
              ><img src="@/assets/images/back.png" alt="返回"
            /></span>
            上一題
          </button>
          <div class="test__image">
            <img
              :src="require(`@/assets/images/questions/${item.image}`)"
              :alt="item.title"
            />
          </div>
          <div class="test__card">
            <div class="test__pager">
              <span class="test__index">{{ index + 1 }}</span
              >/ <span class="test__count">{{ count }}</span>
            </div>
            <div class="test__title">{{ item.title }}</div>
            <div class="test__options">
              <button
                :class="[
                  'test__option',
                  { 'test__option--active': result[index] === optionIndex },
                ]"
                v-for="(option, optionIndex) in item.options"
                :key="optionIndex"
                @click.prevent="next(option, index, optionIndex)"
              >
                <label class="test__label" :for="option.title">
                  <input
                    class="test__radio"
                    :id="option.title"
                    type="radio"
                    :value="optionIndex"
                    :name="item.title"
                    v-model="result[index]"
                  />
                  <span class="test__customRadio"></span>
                  {{ option.title }}</label
                >
              </button>
            </div>
            <div class="test__buttons" v-if="index === 11">
              <button
                class="main-button test__resultButton"
                :disabled="result.length < count"
                @click="showResult"
              >
                查看結果
              </button>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="test__pagination" slot="pagination"></div>
    </swiper>
    <AlertModal v-show="showAlert"
    title="確定要離開？"
    text="測驗進度將會保留"
    cancelText="繼續測驗"
    confirmText="離開"
    :confirmCallback="confirmCallback"
    :cancelCallback="cancelCallback"/>
  </div>
  <InvestmentTestResult v-else :score="score" @restart="restart" />
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import InvestmentTestResult from '@/components/InvestmentTestResult';
import AlertModal from '@/components/AlertModal';
import { addELK } from '@/plugins/elk';

const testTypes = {
  testA: 'testA',
  testB: 'testB',
};

const tests = {
  testA: [
    {
      title: '你平日的工作時間都在？',
      image: 'seat.png',
      options: [
        {
          title: '我可以自由安排時間',
          score: 5,
        },
        {
          title: '我是排休族，不一定',
          score: 4,
        },
        {
          title: '我是薪水小偷，我驕傲',
          score: 3,
        },
        {
          title: '偶爾可以摸個魚，看網頁划划手機',
          score: 2,
        },
        {
          title: '完全無法用電腦划手機',
          score: 0,
        },
      ],
    },
    {
      title: '你對股票的印象是？',
      image: 'money.png',
      options: [
        {
          title: '賺零用錢',
          score: 5,
        },
        {
          title: '幫自己加薪',
          score: 3,
        },
        {
          title: '中長期增加資產',
          score: 1,
        },
        {
          title: '退休規劃/幫小孩買',
          score: 0,
        },
      ],
    },
    {
      title: '網購時看到正在猶豫要不要買的物品僅剩「最後一個」時，你會？',
      image: 'accountChange.png',
      options: [
        {
          title: '秒買，怕錯過就買不到了',
          score: 5,
        },
        {
          title: '尋求身邊的人的意見',
          score: 4,
        },
        {
          title: '照自己的節奏考慮，錯過就算了',
          score: 2,
        },
        {
          title: '沒感覺，覺得之後一定都還會賣',
          score: 1,
        },
      ],
    },
    {
      title: '在餐廳點餐時，你會有選擇障礙嗎？',
      image: 'clickBuy.png',
      options: [
        {
          title: '總是可以馬上決定要點什麼',
          score: 5,
        },
        {
          title: '考慮一下就可以決定點什麼',
          score: 3,
        },
        {
          title: '超級選擇障礙，常需要問別人意見',
          score: 2,
        },
      ],
    },
    {
      title: '對於自己相信的事情',
      image: 'talkStocks.png',
      options: [
        {
          title: '如果消息、友人、輿論都不支持，我會改變想法並附和他們',
          score: 5,
        },
        {
          title: '如果消息、友人、輿論都不支持，我可能會改變想法',
          score: 3,
        },
        {
          title: '不管任何人說什麼我都不會動搖',
          score: 1,
        },
      ],
    },
    {
      title: '當你上班已經遲到，電梯卻一直遲遲不下來時，你會?',
      image: 'clickUp.png',
      options: [
        {
          title: '忍不住一直按，就算知道不會比較快',
          score: 4,
        },
        {
          title: '會按個兩三下以上',
          score: 3,
        },
        {
          title: '心平氣和的慢慢等',
          score: 1,
        },
      ],
    },
    {
      title: '以下哪個選項最接近你的消費習慣？',
      image: 'moneyHouse.png',
      options: [
        {
          title: '我是月光族，收入大部分會變成喜歡的東西',
          score: 4,
        },
        {
          title: '沒有一定的習慣',
          score: 3,
        },
        {
          title: '我每個月都會固定存收入的一部分',
          score: 1,
        },
      ],
    },
    {
      title: '如果你現在開始認真學投資，你希望你是？',
      image: 'reporterLetter.png',
      options: [
        {
          title: '每天花很多時間，接收所有的資訊',
          score: 5,
        },
        {
          title: '每天花半小時 ~ 1小時接受重要新聞',
          score: 4,
        },
        {
          title: '每幾天追蹤重要訊息就好',
          score: 2,
        },
        {
          title: '我覺得一直關注好累，我想學被動投資',
          score: 0,
        },
      ],
    },
    {
      title: '對於你自己訂下的紀律（例如運動、作息、飲食…）',
      image: 'gear.png',
      options: [
        {
          title: '我總是可以好好的執行',
          score: 5,
        },
        {
          title: '偏向於有時候可以 有時候不行',
          score: 3,
        },
        {
          title: '我總是三分鐘熱度，紀律好難！',
          score: 2,
        },
      ],
    },
    {
      title: '你覺得「股票的波動」幾%是正常範圍內？',
      image: 'lineChart.png',
      options: [
        {
          title: '3%',
          score: 4,
        },
        {
          title: '8%',
          score: 3,
        },
        {
          title: '15%',
          score: 2,
        },
        {
          title: '30%',
          score: 1,
        },
      ],
    },
    {
      title: '你的個性最接近於下列哪一項？',
      image: 'trendUp.png',
      options: [
        {
          title: '做任何事很需要看到短期要有回報',
          score: 5,
        },
        {
          title: '中立',
          score: 3,
        },
        {
          title: '短期沒效果沒關係，我比較在意長期的累積結果',
          score: 1,
        },
      ],
    },
  ],
  testB: [
    {
      title: '你平日看盤的習慣是？',
      image: 'electronicReporter.png',
      options: [
        {
          title: '我非常頻繁在看盤',
          score: 5,
        },
        {
          title: '每小時都會看',
          score: 4,
        },
        {
          title: '開盤/收盤看一下而已',
          score: 3,
        },
        {
          title: '因為上班，完全無法看盤',
          score: 2,
        },
        {
          title: '沒有每天看的習慣',
          score: 1,
        },
      ],
    },
    {
      title: '請問對你而言買股票的用意最接近下面哪一項？',
      image: 'target.png',
      options: [
        {
          title: '賺股票價差',
          score: 5,
        },
        {
          title: '抱著等有一天賺錢賣掉',
          score: 3,
        },
        {
          title: '參與投資好公司',
          score: 1,
        },
        {
          title: '存股/領股息',
          score: 0,
        },
      ],
    },
    {
      title: '看到日線直線飆漲的股票，你的感受是？',
      image: 'trend.png',
      options: [
        {
          title: '追，我可以照紀律進出場，不怕！',
          score: 5,
        },
        {
          title: '好想追！可是追了我又怕套',
          score: 4,
        },
        {
          title: '我可以耐心的等拉回再買',
          score: 3,
        },
        {
          title: '心如止水，完全不喜歡追買股票',
          score: 1,
        },
      ],
    },
    {
      title: '買進股票後，股價一直在±5%內震盪，多久你會開始不耐煩？',
      image: 'chart.png',
      options: [
        {
          title: '1-3天',
          score: 5,
        },
        {
          title: '一週',
          score: 4,
        },
        {
          title: '一個月',
          score: 1,
        },
        {
          title: '只要不大跌套牢都沒問題',
          score: 2,
        },
        {
          title: '正常吧！不會不耐煩阿',
          score: 0,
        },
      ],
    },
    {
      title: '對於買賣股票的頻率，你最趨向於？',
      image: 'change.png',
      options: [
        {
          title: '隨時要買要賣都能馬上執行',
          score: 5,
        },
        {
          title: '對買賣有選擇障礙',
          score: 3,
        },
        {
          title: '很容易會「再看看」',
          score: 2,
        },
        {
          title: '我不喜歡頻繁的買賣',
          score: 1,
        },
      ],
    },
    {
      title: '面臨套牢時，你最常會覺得？',
      image: 'trendDown.png',
      options: [
        {
          title: '遵守紀律的我不太會讓自己抱到套牢',
          score: 5,
        },
        {
          title: '再給他一段時間，回到成本便賣出',
          score: 4,
        },
        {
          title: '乾脆不看了，蓋牌',
          score: 2,
        },
        {
          title: '波動乃兵家常事，隨遇而安',
          score: 1,
        },
      ],
    },
    {
      title: '聽到朋友在討論似乎有可信度的名牌時，你的想法是？',
      image: 'phonetalk.png',
      options: [
        {
          title: '有動直接追',
          score: 5,
        },
        {
          title: '相信朋友，直接買進丟著等',
          score: 3,
        },
        {
          title: '自己花時間研究，等有動再來考慮',
          score: 4,
        },
        {
          title: '不喜歡聽名牌',
          score: 1,
        },
      ],
    },
    {
      title: '你平均持有的股票檔數為幾檔？',
      image: 'moneyArrow.png',
      options: [
        {
          title: '1-3檔',
          score: 1,
        },
        {
          title: '5-8檔',
          score: 3,
        },
        {
          title: '10檔以上',
          score: 5,
        },
      ],
    },
    {
      title: '對於接收市場的訊息，你偏向於？',
      image: 'reporter.png',
      options: [
        {
          title: '個股、總經、產業，我全部都要！每天花再多時間都可以',
          score: 5,
        },
        {
          title: '我關注跟我持股有關的任何傳聞/消息/新聞',
          score: 4,
        },
        {
          title: '我每天有空閒時會關注重點新聞',
          score: 2,
        },
        {
          title: '我沒有每天在關注財經新聞',
          score: 0,
        },
      ],
    },
    {
      title: '當市場空頭行情時，你的感受最偏向於？',
      image: 'trendBear.png',
      options: [
        {
          title: '我做空',
          score: 5,
        },
        {
          title: '等到有多頭行情我再回來',
          score: 3,
        },
        {
          title: '跳樓大拍賣，找機會買好公司',
          score: 0,
        },
      ],
    },
    {
      title: '你喜歡跟別人討論股票的漲跌',
      image: 'talkStocks.png',
      options: [
        {
          title: 'YES',
          score: 5,
        },
        {
          title: 'NO',
          score: 1,
        },
      ],
    },
  ],
};
export default {
  name: 'InvestmentTest',
  props: {
    resultDefault: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiper: null,
      count: 12,
      result: [],
      testType: testTypes.testA,
      swiperOption: {
        allowTouchMove: false,
        pagination: {
          el: '.test__pagination',
          type: 'progressbar',
        },
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
      },
      isResult: false,
      score: 0,
      showAlert: false,
    };
  },
  computed: {
    index() {
      return this.swiper.realIndex;
    },
    testItems() {
      return [
        {
          title: '請問你的股市投資經驗為何？',
          image: 'man.png',
          options: [
            {
              title: '完全沒經驗',
              testType: testTypes.testA,
            },
            {
              title: '有經驗，但不會每天打開看盤軟體',
              testType: testTypes.testA,
            },
            {
              title: '每天會看股票，持續一年以上',
              testType: testTypes.testB,
            },
            {
              title: '買賣股票體驗過多空循環',
              testType: testTypes.testB,
            },
          ],
        },
        ...tests[this.testType],
      ];
    },
    progress() {
      if (this.swiper) {
        return (((this.swiper.realIndex + 1) / this.count) * 100).toFixed(0);
      }
      return 0;
    },
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
  },
  created() {
    window.addEventListener('popstate', () => {
      if (this.result.length > 0 && !this.isResult) {
        // 開啟確認視窗
        this.showAlert = true;
      } else {
        window.history.back();
      }
    }, false);
  },
  methods: {
    // 重新測驗
    restart() {
      this.$emit('restart');
      // this.isResult = false;
      // this.score = 0;
      // this.result = [];
    },
    handleSwiperComponentReady(swiper) {
      this.swiper = swiper;
      this.result = this.resultDefault;
      if (this.resultDefault.length) {
        this.swiper.slideTo(this.resultDefault.length, 500);
      }
    },
    next(option, index, optionIndex) {
      if (optionIndex === undefined) {
        return;
      }
      if (this.result[index] !== undefined) {
        this.$set(this.result, index, optionIndex);
        return;
      }
      this.$set(this.result, index, optionIndex);
      if (option.testType) {
        this.testType = option.testType;
      }
      setTimeout(() => {
        if (this.swiper.isEnd) {
          this.swiper.update();
        } else {
          this.swiper.slideNext(500);
        }
      }, 100);
    },
    prev() {
      const previousIndex = this.index - 1;
      const count = this.result.length - previousIndex;
      this.swiper.slidePrev();
      setTimeout(() => {
        this.result.splice(previousIndex, count);
      }, 250);
      addELK('Previous_Topic', {
        Parameter: '上一題',
      });
    },
    showResult() {
      this.isResult = true;
      this.score = 0;
      this.result.forEach((value, index) => {
        const option = this.testItems[index].options[value];
        if (option.score) {
          this.score += option.score;
        }
      });
      // 若有localStorage需要清除
      const dataString = window.localStorage.blueTest;
      if (dataString) {
        const data = JSON.parse(dataString);
        const index = data.findIndex(
          (item) => item.user === this.userInfo.nickname,
        );
        if (index > -1) {
          data.splice(index, 1);
        }
        window.localStorage.setItem('blueTest', JSON.stringify(data));
      }
      addELK('View_Results', {
        Parameter: '查看結果',
      });
    },
    confirmCallback() {
      // 留下測驗紀錄
      let data = [];
      const dataString = window.localStorage.getItem('blueTest');
      let hasUser = false;
      if (dataString) {
        data = JSON.parse(dataString);
        const item = data.find((i) => i.user === this.userInfo.nickname);
        if (item) {
          hasUser = true;
          item.result = this.result;
        }
      }
      if (!hasUser) {
        data.push({
          user: this.userInfo.nickname,
          result: this.result,
        });
      }
      window.localStorage.setItem('blueTest', JSON.stringify(data));
      // 跳轉到上一頁
      window.history.back();
      this.showAlert = false;
    },
    cancelCallback() {
      this.showAlert = false;
      if (
        window.history.state === null
        || !window.history.state.key
        || window.history.state.key !== 'blueTest start'
      ) {
        window.history.pushState(
          { key: 'blueTest start' },
          'start test',
          '#start',
        );
      }
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    InvestmentTestResult,
    AlertModal,
  },
};
</script>

<style scoped>
.test {
  position: relative;
}
.test__wrapper {
  padding-top: 82px;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
  min-height: 100vh;
}
.test__container {
  box-shadow: 26px 26px 80px #26262633;
  box-sizing: border-box;
  border-radius: 16px;
}
.test__progress {
  position: absolute;
  top: 18px;
  right: 16px;
}
.test .swiper-container > .test__pagination {
  top: 24px;
  left: 16px;
  height: 6px;
  border-radius: 100px;
  overflow: hidden;
  width: 80%;
}

.test__pagination:deep .swiper-pagination-progressbar-fill {
  background: #FFB13B;
  border-radius: 100px;
}
.test__prevButton {
  position: absolute;
  top: 46px;
  background-color: transparent;
  font-size: 14px;
  line-height: 28px;
  color: #595959;
  border: none;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius:3px ;
  cursor: pointer;
}
.test__prevButton:hover{
  background-color: rgba(38, 38, 38, 0.04)
;
}
.test__prevButton:active{
  background-color: rgba(38, 38, 38, 0.13);
}
.test__prevIcon {
  width: 16px;
  display: inline-block;
  line-height: 10px;
  margin-right: 3px;
}
.test__card {
  background-color: #fff;
  padding: 10px 16px 16px;
  border-radius: 0 0 16px 16px;
}
.test__pager {
  padding: 6px 0;
  font-size: 16px;
  color: #bfbfbf;
  display: flex;
  align-items: center;
}
.test__index {
  font-size: 36px;
  color: #262626;
  margin-right: 3px;
}
.test__count {
  font-size: 24px;
  margin-left: 3px;
}
.test__title {
  padding: 8px 0 18px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 900;
}
.test__options {
  display: flex;
  flex-direction: column;
  font-size: 16px;
}
.test__option {
  line-height: 24px;
  background-color: #fff;
  margin: 6px 0;
  text-align: left;
  border: 1px solid #e4e4e4;
  position: relative;
  padding: 12px 16px 12px 44px;
  transition: 0.8s;
}
.test__option--active {
  border: 1px solid #FFB13B;
  background-color: rgba(255, 177, 59, 0.2);
  transition: 0s;
}
.test__label {
  display: inline-block;
  width: 100%;
  height: 100%;
  color: #000000;
  font-size: 16px;
}
.test__radio {
  display: none;
}
.test__customRadio {
  position: absolute;
  top: 50%;
  left: 16px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  transform: translateY(-50%);
  border: 2px solid #bfbfbf;
  box-sizing: border-box;
}
.test__radio:checked ~ .test__customRadio {
  border: 2px solid #FFB13B;
}
.test__customRadio:after {
  content: "";
  position: absolute;
  display: none;
}
.test__radio:checked ~ .test__customRadio:after {
  display: block;
}

.test__radio ~ .test__customRadio:after {
  width: 8px;
  height: 8px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: #FFB13B;
}
.test__buttons {
  display: flex;
  justify-content: center;
  padding-top: 32px;
}
.test__resultButton {
  padding: 0 16px;
  font-size: 16px;
}
</style>
